// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 justify-center>
        <v-card>
          <v-card-title class="display-2">
            License Server
          </v-card-title>
          <v-card-text class="headline">
            <p>Total Active Licenses: {{ licensesActive }}</p>
            <p>Total Inactive Licenses: {{ licensesInactive }}</p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import ApiRequests from '@/api/ApiRequests'
import {ENDPOINT} from '@/shared/constants'

export default {

  data () {
    return {
      licensesActive: 0,
      licensesInactive: 0,
      endpoint: ENDPOINT
    }
  },

  created () {
    ApiRequests.getLicenses(true).then((response) => {
      this.licensesActive = response.data.length
    })

    ApiRequests.getLicenses(false, true).then((response) => {
      this.licensesInactive = response.data.length
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue